__turbopack_context__.v({
  "bubbleNavigationWrapper": "styles-module__bED5aq__bubbleNavigationWrapper",
  "description": "styles-module__bED5aq__description",
  "headerContent": "styles-module__bED5aq__headerContent",
  "headerContentContainer": "styles-module__bED5aq__headerContentContainer",
  "headerWrapper": "styles-module__bED5aq__headerWrapper",
  "image": "styles-module__bED5aq__image",
  "popularBrandsWrapper": "styles-module__bED5aq__popularBrandsWrapper",
  "retakeQuizButton": "styles-module__bED5aq__retakeQuizButton",
});
